import { render, staticRenderFns } from "./CoolSmallCard.vue?vue&type=template&id=e2cf2384&scoped=true&"
import script from "./CoolSmallCard.vue?vue&type=script&lang=js&"
export * from "./CoolSmallCard.vue?vue&type=script&lang=js&"
import style0 from "./CoolSmallCard.vue?vue&type=style&index=0&id=e2cf2384&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cf2384",
  null
  
)

export default component.exports